import type { RegionNode } from '../../../api/regions';
import { regionNameById } from '../workshops/create/workshopCreateRegions';

import type { VenueCreateForm } from './useVenueCreateForm';
import { ASSIGN_FROM_STATE } from './venueCreateFields';

export function ReviewStep({ form, regions }: { form: VenueCreateForm; regions: RegionNode[] }) {
  const { stage, fields, regionId, submitError } = form;
  const rows: ReadonlyArray<readonly [string, string]> = [
    ['Status', stage === 'prospect' ? 'Prospect' : 'Active'],
    ['Name', fields.name || '—'],
    ['Domain', fields.domain || '—'],
    [
      'Address',
      fields.addressLine1
        ? `${fields.addressLine1} · ${fields.city}, ${fields.state} ${fields.zipCode}`
        : '—',
    ],
    ['Region', regionId ? regionNameById(regions, regionId) : ASSIGN_FROM_STATE],
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ border: '1px solid var(--nb-border)', borderRadius: 10, overflow: 'hidden' }}>
        {rows.map(([k, v], i) => (
          <div
            key={k}
            style={{
              display: 'flex',
              gap: 10,
              padding: '8px 12px',
              borderBottom: i < rows.length - 1 ? '1px solid var(--nb-border)' : 'none',
              fontSize: 11.5,
            }}
          >
            <span style={{ width: 70, color: 'var(--nb-subtle)', fontWeight: 700 }}>{k}</span>
            <span style={{ color: 'var(--nb-ink)' }}>{v}</span>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 10.5, color: 'var(--nb-subtle)', lineHeight: 1.5 }}>
        Capacity, contact and logistics live on the venue page.
      </div>
      {submitError && <div style={{ fontSize: 11.5, color: '#c0392b' }}>{submitError}</div>}
    </div>
  );
}
